// @ts-strict-ignore
import { colorMix } from 'src/theme/color-palettes';

export default {
  css: ({ dt }) => {
    return `
      .p-datatable > .p-overlay-mask {
        background: ${colorMix(dt('gray.300'), 30)};
        color: ${dt('text-color')};
      }
      .p-datatable-tbody > tr:last-child > td {
        border-bottom:0;
      }
      .p-datatable-thead > tr > th {
        font-size: 0.875rem;
      }
      .p-datatable-tbody > tr > td {
        font-size: 0.875rem;
      }
      .p-datatable-tfoot > tr > td {
        font-size: 0.875rem;
      }
    `;
  },
};
